import styled, { css } from 'styled-components';
import { variant } from 'styled-system';

import { ThemeUtilities } from '../../../theme';
import { Color, Variant, Border } from './types';

export const Container = styled.div<{
  color: Color;
  variant: Variant;
  border: Border;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Card', 'variant'))};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Card', 'color'))};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Card', 'border'))};

  ${css((props) => ThemeUtilities.getComponentCSSOverrides(props, 'Card'))};
`;

export const Header = styled.div<{
  headerVariant?: Variant;
  enableBorder?: boolean;
}>`
  flex-shrink: 0;

  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'Card', 'headerVariant')
    )};

  ${({ enableBorder }) =>
    !enableBorder &&
    css`
      border-bottom-width: 0;
    `};
`;

Header.defaultProps = {
  headerVariant: 'regular',
  enableBorder: true,
};

export const Footer = styled.div<{ footerVariant?: Variant }>`
  flex-shrink: 0;
  margin-top: auto;

  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'Card', 'footerVariant')
    )};
`;

Footer.defaultProps = {
  footerVariant: 'regular',
};
